export default {"src":"https://fishbrain.com/_next/static/media/colorado.d24f13cf.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};